module.exports = __webpack_public_path__ + "static/media/pod_winnerEffect.bf3e2fb8.png";